const TOKEN_EXPIRED_EVENT = "token-expired";

let hasEmittedTokenExpired = false;

export const emitTokenExpired = (): void => {
  if (hasEmittedTokenExpired) {
    return;
  }

  hasEmittedTokenExpired = true;
  window.dispatchEvent(new CustomEvent(TOKEN_EXPIRED_EVENT));
};

export const listenTokenExpired = (handler: () => void): (() => void) => {
  const listener = () => {
    handler();
  };

  window.addEventListener(TOKEN_EXPIRED_EVENT, listener);

  return () => {
    window.removeEventListener(TOKEN_EXPIRED_EVENT, listener);
  };
};

export const resetTokenExpiredEvent = (): void => {
  hasEmittedTokenExpired = false;
};
